onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    context.querySelectorAll('a[data-event]').forEach(element => {
        element.addEventListener('click', () => sendEvent(element));
    });

    context.querySelectorAll('form[data-event]').forEach(element => {
        element.addEventListener('valid', () => sendEvent(element));
    });
}

function sendEvent(element) {
    dataLayer.push({
        'event': element.dataset.event,
        'eventCategory': element.dataset.eventCategory,
        'eventAction': element.dataset.eventAction,
        'eventLabel': element.dataset.eventLabel
    });
}